<template>
  <div class="space-y-6">
    <div class="space-y-3">
      <StackedField :label="t('claim_type')" :value="claimTypeLabel" />
      <StackedField
        v-if="declaration.breakdownImpactOrDrop != null"
        :label="t('claim.declaration_field.breakdown_impact_or_drop')"
        :value="t(declaration.breakdownImpactOrDrop ? 'yes' : 'no')"
      />
      <StackedField :label="t('description')">
        <span class="whitespace-pre-line">{{ declaration.description }}</span>
      </StackedField>
    </div>

    <div v-if="planSaleFriendlyId">
      <h3 class="text-lg font-bold text-gray-900">{{ t("previous_claims") }}</h3>
      <ClaimsIndex class="mt-3" :plan-sale-friendly-id="planSaleFriendlyId" :exclude-claim-id="claim.friendlyId" />
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { StackedField } from "@estaly/ui";
import ClaimsIndex from "@/components/claim/details/information/ClaimsIndex.vue";

export default {
  name: "AiAnalysisContextStep",

  components: { StackedField, ClaimsIndex },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    claim: {
      type: Object,
      required: true,
    },
    declaration: {
      type: Object,
      required: true,
    },
  },

  computed: {
    // Le type de sinistre porte la clé globale du BO, comme le badge de l'en-tête de la fiche.
    claimTypeLabel() {
      return this.claim.claimType ? this.t(`claim.claim_type.${this.claim.claimType}`) : "";
    },
    // Les sinistres précédents se cherchent par contrat : sans contrat, pas d'historique à montrer.
    planSaleFriendlyId() {
      return this.claim.planSale?.friendlyId;
    },
  },
};
</script>

<i18n src="./AiAnalysisContextStep.i18n.json"></i18n>
